import React, { useState, useEffect } from "react";
import { Button, Space, message } from "antd";
import axios from "axios";
import GenericTable from "../components/GenericTable";
import GenericModal from "../components/GenericModal ";
import GenericViewDrawer from "../components/GenericViewModal";
import AppMenu from "../components/AppMenu";
import { format } from "date-fns";
import "./Providers.css"

const Providers = () => {
  const [providers, setProviders] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentProvider, setCurrentProvider] = useState(null);
  const [isViewDrawerVisible, setIsViewDrawerVisible] = useState(false);
  const [viewDrawerData, setViewDrawerData] = useState(null);

  const [page, setPage] = useState(1); // Current page
  const [limit] = useState(10); // Items per page
  const [search, setSearch] = useState(""); // Search query

  const [total, setTotal] = useState(0);


  useEffect(() => {
    fetchProviders();
  }, []);

  useEffect(() => {
    fetchProviders();
  }, [search, page]); // Add page as dependency

  // Fetch providers
  const fetchProviders = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/api/providers`, {
        params: { page, limit, search },
      });
  
      const { data: providers } = response.data; // Extract total count
      const total = response.data.meta.total; // Extract total count
      console.log("API Response - Total:", total, "Current Page:", page, "Limit:", limit); // Debug pagination
      console.log("Pagination calculation - Should show", Math.ceil(total / limit), "pages"); // Debug page count
      
      const formattedProviders = providers.map((provider) => ({
        ...provider,
        isActive: provider.isActive ? "ACTIVE" : "INACTIVE",
        createdAt: format(new Date(provider.createdAt), "MM/dd/yyyy, HH:mm:ss"),
        updatedAt: format(new Date(provider.updatedAt), "MM/dd/yyyy, HH:mm:ss"),
      }));
  
      setProviders(formattedProviders);
      setTotal(total); // Set total items for pagination
    } catch (error) {
      console.error("Error fetching providers:", error);
      message.error("Failed to load providers");
    }
  };


  const handleSearchChange = (value) => {
    console.log("Search Value in Parent:", value);
    setSearch(value);
    setPage(1); // Reset to first page when searching
  };

  // Handle viewing provider details
  const handleViewDetails = (provider) => {
    setViewDrawerData(provider);
    setIsViewDrawerVisible(true);
  };

  // Handle toggling provider status
  const handleToggleStatus = async (provider) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_API}/api/providers/${provider.id}/activate`,
        {}
      );
      message.success("Provider status changed successfully");
      fetchProviders();
    } catch (error) {
      console.error("Error toggling provider status:", error);
      message.error("Failed to change provider status");
    }
  };
  const onPageChange = (pageNumber) => {
    setPage(pageNumber); // Update the current page - fetchProviders will be called by useEffect
  };

  const handleCreateUpdateProvider = async (formData) => {
    try {
      if (currentProvider) {
        delete formData.updatedAt;
        delete formData.createdAt;
        // Update provider
        await axios.patch(`${process.env.REACT_APP_API}/api/providers/${currentProvider.id}`, formData);
        message.success('Provider updated successfully');
      } else {
        // Create new provider
        await axios.post(`${process.env.REACT_APP_API}/api/providers`, formData);
        message.success('Provider created successfully');
      }
      fetchProviders(); // Refresh provider list
      setIsModalVisible(false); // Close modal after action
      setCurrentProvider(null); // Reset current provider
    } catch (error) {
      console.error('Error creating/updating provider:', error);
      message.error('Failed to save provider');
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <AppMenu />
      <div className="providers-page">
        <Space style={{ marginBottom: 20, marginRight: 20, marginTop: 20, display: "flex", justifyContent: "end" }}>
          <Button type="primary" onClick={() => setIsModalVisible(true)}>
            Create Provider
          </Button>
        </Space>
        <GenericTable
          data={providers}
          searchKeys={["name", "label"]}
          sortableColumns={["name", "label"]}
          actions={["Toggle Status", "View"]}
          actionFunctions={[
            (provider) => handleToggleStatus(provider),
            (provider) => handleViewDetails(provider),
          ]}
          toggle="isActive"
          pagination={{
            current: page,
            pageSize: limit,
            total: total,
            onChange: onPageChange,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            hideOnSinglePage: false, // Always show pagination controls
          }}
          onSearch={handleSearchChange}
        />


        {/* View Drawer */}
        <GenericViewDrawer
          isVisible={isViewDrawerVisible}
          handleCancel={() => setIsViewDrawerVisible(false)}
          data={viewDrawerData}
          title="Provider Details"
          footerButtons={["Close"]}
          onButtonClick={() => setIsViewDrawerVisible(false)}
          
        />

        {/* Modal for Create/Update Provider */}
        <GenericModal
          isVisible={isModalVisible}
          handleOk={(formData) => console.log("Save Provider", formData)}
          handleCancel={() => setIsModalVisible(false)}
          title="Create Provider"
          inputs={[
            { label: "Name", name: "name", type: "text", placeholder: "Enter provider name", require: true },
            { label: "Label", name: "label", type: "text", placeholder: "Enter provider label", require: true },
          ]}
          actions={["Submit", "Cancel"]}
          actionFunctions={[
            (formData) => handleCreateUpdateProvider(formData),
            () => setIsModalVisible(false),
          ]}
        />
      </div>
    </div>
  );
};

export default Providers;
